import { Injectable } from '@angular/core';
import { Actions, Effect , ofType} from '@ngrx/effects';
import { Router } from '@angular/router';
import { of, Observable } from 'rxjs';
import { tap, switchMap, map, catchError } from 'rxjs/operators';

import * as rangosMPAllActions from '../../../actions';
import { Action } from '@ngrx/store';
import { rangosMPService } from 'src/app/services/SicarMap/Modelos/rangosMP.service';

@Injectable()
export class rangoMPEffects {

    constructor(
    private actions$: Actions,
    private rangosMPServicio: rangosMPService,
    ) {}

    @Effect()
    SetRangoMPAction: Observable<Action> = this.actions$.pipe(
        ofType(rangosMPAllActions.SET_RangoMP),
        switchMap((action: rangosMPAllActions.SetRangoMPAction) => {
            return this.rangosMPServicio.setRangoMP(action.rangosMP)
                  .pipe(
                      map((Datos: boolean) => {
                          return new rangosMPAllActions.SetRangoMPSuccesAction();
                      }),
                      catchError(error => of (new rangosMPAllActions.SetRangoMPFailureAction({ error })))
                  );
    }));
}